import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthService } from '../../services/auth/auth.service';
import { Subject, filter, takeUntil } from 'rxjs';
import { InteractionStatus } from '@azure/msal-browser';
import { RoleType } from '../../shared/enums/role-type/role-type.module';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.css'
})
export class AuthComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private msalService: MsalService,
    private authService: AuthService,
    private msalBroadcastService: MsalBroadcastService
  ) { }
  private readonly _onDestroy$ = new Subject<void>();
  isLoading: boolean = false;
  ngOnInit() {
    this.isLoading = true;
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._onDestroy$)
      )
      .subscribe(() => {
        const account = this.msalService.instance.getAllAccounts()[0];
        if (account) {
          this.authService.transformToken().subscribe((response: boolean) => {
            this.isLoading = false;
            var pathName = this.authService.getPathName();
            if (!pathName || pathName?.includes('admin')) {
              this.authService.loadUserRole()
              this.authService.getUserRoleNotAsync().subscribe(role => {
                if (role != null && role == RoleType.ADMIN) {
                  this.router.navigate(['/admin/pages']);
                }
                else {
                  this.router.navigate(['/']);
                }
              });
            }
            else if (pathName) {
              this.router.navigate([pathName]);
            }
            else {
              this.router.navigate(['/']);
            }
          });
        } else {
            var pathName = this.authService.getPathName();
            this.router.navigate([pathName]);
        }
      });
  }

  ngOnDestroy(): void {
      this._onDestroy$.next();
      this._onDestroy$.complete();
  }
}
